import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { routes } from 'utils/routing';

import theme from './theme';

export interface ISubcategoryBreadcrumbs extends React.HTMLAttributes<HTMLDivElement> {
  currentSectionName: string;
}

const Wrapper = styled.div`
  font-size: 1.125rem;
  margin: 1rem 1rem -2rem 1rem;
  color: ${theme.wrapperColor};
  text-align: center;

  ${Styles.desktop`
    text-align: left;
  `};

  a {
    color: ${Styles.color.primary};

    &:hover {
      color: ${Styles.color.primaryHover};
    }
  }
`;

export const SubcategoryBreadcrumbs: FC<ISubcategoryBreadcrumbs> = ({
  currentSectionName,
  ...props
}) => {
  const { formatMessage } = useIntl();
  return (
    <Wrapper {...props}>
      {/* link to list of all categories, unsetting the selected order */}
      <Link to={routes.support}>{formatMessage({ id: 'supportTopicsAll' })}</Link> /{' '}
      {currentSectionName}
    </Wrapper>
  );
};
